import styled from 'styled-components'

import LiveTooltip from 'live/components/ui/tooltip'

export const OperationBowtieItemStyled = styled.div`
    display: grid;
    grid-template-areas: 'DE ST BP BM';
    grid-template-columns: 1fr 70px 55px 55px;
    grid-template-rows: 1fr;
    gap: 12px;

    .operation-bowtie-details {
        pointer-events: none;
        position: relative;
        grid-area: DE;
        flex: 1;
        display: flex;
        flex-direction: column;
        font-family: var(--font-semibold);

        > div {
            width: min-content;
            max-width: calc(340px - 70px - 55px - 55px - 16px * 3);
            pointer-events: auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 14px;
            cursor: pointer;
        }

        .operation-bowtie-name {
            color: var(--blue-500);
            font-size: 9px;
        }

        .operation-bowtie-description {
            font-size: 11px;
            color: var(--gray-800);
        }
    }

    .operation-bowtie-status {
        grid-area: ST;

        display: flex;
        justify-content: center;
        align-items: center;

        i {
            margin-right: 4px;
        }
    }

    .operation-bowtie-barrier-count {
        font-size: 13px;
        line-height: 28px;
        color: var(--gray-600);
        text-align: center;
        vertical-align: middle;

        &.prevention {
            grid-area: BP;
        }

        &.mitigation {
            grid-area: BM;
        }

        span {
            font-family: var(--font-semibold);
            font-size: 16px;
            color: var(--gray-800);
        }
    }
`

export const StyledCustomTooltip = styled(LiveTooltip)`
    transform: translate(38px, 0);

    .tooltip-arrow {
        left: 16px !important;
    }
`
